import { call, put, takeEvery } from 'redux-saga/effects';
import {
  createBookmarkRequest,
  createBookmarkSuccess,
  createBookmarkFailure,
} from '../slice/createBookmarkSlice';
import { createBookmarkApi } from '@src/api/apiService';


interface BookmarkErrorResponse { error?: string; session_id?: string[]; }
interface ApiError { response?: { data?: BookmarkErrorResponse; }; message?: string; }
// Worker saga
export function* handleCreateBookmark(action: ReturnType<typeof createBookmarkRequest>): Generator<any, void, any> {
  try {
    const response = yield call(createBookmarkApi as any, action.payload);
    yield put(createBookmarkSuccess(response.data));
  } catch (error: unknown) {
    const apiError = error as ApiError;
    yield put(
      createBookmarkFailure(
        apiError?.response?.data?.error || apiError.message || 'Unknown error'
      )
    );
  }
}

// Watcher saga
export function* createBookmarkSaga() {
  yield takeEvery(createBookmarkRequest.type, handleCreateBookmark);
}
